//Imports
import React from "react";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import ResponsiveAppBar from "../../../../components/appbar";
import Footer from "../../../../components/footer";


//Function Starts
export default function Timpage(){

    //Functions & Declarations

    let navigate = useNavigate();


 
    const opendetailedweek = () => {
        navigate("/intern/people/tim/detailedweek")
    }

//Rendered Parts starts

    return(
      <div>
          <ResponsiveAppBar/>
            
            
          <Footer/>
      </div>




    );


}